import { API_URL } from "../config/variables";
import fetchApi from "./fetchApi";

export const DownloadCardholderCsvTemplate = async () => {
    try {
        const response = await fetchApi(`card-issuing/cardholder/bulk/template`, {
            method: 'GET',
            redirect: 'follow'
        });

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'cardholder_template.csv'; // The desired file name
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

    } catch (error) {
        console.error('Error fetching user data:', error);
        throw error;
    }
};

export const GetPrograms = async () => {
    try {
        return await fetchApi(`card-issuing/cardholder/programs`,{
            method: 'GET',
        });

    } catch (error) {
        console.log(error)
        console.error('Error fetching user data:', error);
        throw error;
    }
};

export const GetPackageCodes = async ({limit, offset, program_id}) => {
    try {
        return await fetchApi(`card-issuing/cardholder/programs/${program_id}/packages?limit=${limit}&offset=${offset}`,{
            method: 'GET',
        });

    } catch (error) {
        console.log(error)
        console.error('Error fetching user data:', error);
        throw error;
    }
};

export const GetProgramFees = async ({program_id}) => {
    try {
        return await fetchApi(`card-issuing/cardholder/programs/${program_id}/fees`,{
            method: 'GET',
        });

    } catch (error) {
        console.error('Error fetching user data:', error);
        throw error;
    }
};

export const GetProvisionalTax = async ({province_code}) => {
    try {
        return await fetchApi(`card-issuing/cardholder/provincial_tax_rates/${province_code}`,{
            method: 'GET',
        });

    } catch (error) {
        console.error('Error fetching user data:', error);
        throw error;
    }
};

export const BulkCreateCardholdersTemplateInfo = async () => {
    try {
        return await fetchApi(`card-issuing/cardholder/bulk/template-info`,{
            method: 'GET',
        });

    } catch (error) {
        console.log(error)
        console.error('Error fetching bulk create cardholders template info:', error);
        throw error;
    }
};

export const ValidateBulkCreateCardholderTemplate = async (file, program_id) => {

    try {
        let formdata = new FormData();

        formdata.append("file", file, file.name);
        formdata.append("program_id", program_id);

        return await fetchApi(`card-issuing/cardholder/bulk/validate`,{
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        });

    } catch (error) {
        console.log(error)
        console.error('Error fetching user data:', error);
        throw error;
    }
}

export const CreateCards = async (file, program_id) => {

    try {
        let formdata = new FormData();

        formdata.append("file", file, file.name);
        formdata.append("program_id", program_id);

        return await fetchApi(`card-issuing/cardholder/bulk`,{
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        });

    } catch (error) {
        console.log(error)
        console.error('Error fetching user data:', error);
        throw error;
    }
}

export const RequestBulkCreateOffices = async () => {
    try {

    } catch (error) {
        console.error('Error bulk creating offices: ', error);
        throw error;
    }
};

export const ValidateBulkCreateOfficesTemplate = async () => {
    try {

    } catch (error) {
        console.error('Error validating bulk create offices template: ', error);
        throw error;
    }
};

export const BulkCreateOfficesTemplateInfo = async () => {
    try {

    } catch (error) {
        console.error('Error validating bulk create offices template: ', error);
        throw error;
    }
};
export const DownloadOfficesCsvTemplate = async () => {
    try {

    } catch (error) {
        console.error('Error validating bulk create offices template: ', error);
        throw error;
    }
};



